'use client';

import React from 'react';
import { ContentPageHero } from '../contentPageHero/contentPageHero.comp';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { Header } from '../header/header.comp';
import { CommonNinjaWidgetRenderer } from '../CommonNinjaWidgetRenderer/commonNinjaWidgetRenderer.comp';

interface IReportAbuseProps {
    type?: 'contact-us' | 'report-abuse';
}

export const ReportAbuse = ({ type = 'report-abuse' }: IReportAbuseProps) => {

    const title = type === 'report-abuse' ? 'Report Abuse' : 'Contact Us';
    const subtitle = type === 'report-abuse' ? '' : 'Have a question or need assistance? Contact the Common Ninja support team by submitting your request. We’re here to help!';
    return (
        <>
            <ContentPageHero
                title={title}
                subtitle={subtitle}
                style={{ paddingBottom: '100px' }}
            />
            <Header />
            <section
                style={{ padding: '100px 20px', marginTop: '-200px' }}
            >
                <Suspense>
                    <Form type={type} />
                </Suspense>
            </section>
        </>
    );
};

function Form({ type }: IReportAbuseProps) {
    const searchParams = useSearchParams();
    const widgetType = searchParams.get('widgetType');
    const widgetId = searchParams.get('widgetId');

    const compId = type === 'report-abuse' ? 'b4e28b26-8c6b-49d7-aff5-a8dd31984b58' : '8ab6e5ae-0e59-4e6a-af8c-1f6b04de746e';
    const widgetProps = type === 'report-abuse' ?
        encodeURIComponent(
            JSON.stringify({
                // widget id
                'text-17566c26': widgetId || '',
                // widget type
                'text-f2124975': widgetType || '',
            })
        )
        :
        '{}';

    return (
        <div style={{minHeight:'700px'}}>
            <CommonNinjaWidgetRenderer
                widgetId={compId}
                widgetProps={widgetProps}
            />
        </div>
    );
}


